import React from 'react';
import { FaLinkedin, FaTwitter, FaGithub } from 'react-icons/fa';

export default function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2026 Emmanuel-Kipngetich.</p>
      <div className="footer-icons">
        <a
          href="https://www.linkedin.com/in/emmanuel-kipngetich-969204267/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
        >
          <FaLinkedin />
        </a>
        <a
          href="https://x.com/Kip__Emmanuel"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="X / Twitter"
        >
          <FaTwitter />
        </a>
        <a
          href="https://github.com/Emmanuel-Deo"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="GitHub"
        >
          <FaGithub />
        </a>
      </div>
    </footer>
  );
}
